import { AspectRatio } from '../models/aspect-ratio';

export function parseAspectRatio(aspectRatio: AspectRatio.Ratios) {
  const split = aspectRatio.split(':');
  return +(split[0] || 1) / +(split[1] || 1);
}
